import $ from 'jquery';

var Events = {
    additionalBrandingNumber : 1,
    selectors: {
        checkbox: $('.events .checkbox-input')
    },

    init: function () {
        this.eventHandler();
        this.addAdditionalBranding();
    },

    eventHandler: function () {
        var selectors = this.selectors;

        selectors.checkbox.change(function () {
            Events.subbrandVisibilityHandler(this);
        });
    },

    subbrandVisibilityHandler: function (checkbox) {
        $(checkbox).parents('.checkbox-label').next('.checkbox-label__subbrand').toggleClass('d-none');
    },

    addAdditionalBranding: function() {
        $('.add_additional_branding').find('a').click(function() {
            Events.additionalBrandingNumber = Events.additionalBrandingNumber + 1;
            var additionalBrandingFields = $('.additional_branding').clone(true);

            //Clear data from cloned block
            additionalBrandingFields.removeClass('additional_branding');
            additionalBrandingFields.addClass('additional-branding-clone');
            additionalBrandingFields.find('.form-s-title span').text(Events.additionalBrandingNumber);

            additionalBrandingFields.find('input[type=text]').each(function(i){
                $(this).val('');
                $(this).attr('name', $(this).data('group') + '[' + Events.additionalBrandingNumber + '][' + $(this).data('name') + ']');
            });

            additionalBrandingFields.find('textarea').each(function(i){
                $(this).val('');
                $(this).attr('name', $(this).data('group') + '[' + Events.additionalBrandingNumber + '][' + $(this).data('name') + ']');
            });

            additionalBrandingFields.find('input[type=checkbox]').each(function(i){
                $(this).attr('checked', false);
                if ($(this).data('name') == 'brands') {
                    $(this).attr('name', $(this).data('group') + '[' + Events.additionalBrandingNumber + '][' + $(this).data('name') + '][]');
                } else {
                    $(this).attr('name', $(this).data('group') + '[' + Events.additionalBrandingNumber + '][' + $(this).data('name') + ']');
                }
            });

            additionalBrandingFields.find('.checkbox-label').removeClass('checkbox-checked');
            additionalBrandingFields.find('.checkbox-label__subbrand').addClass('d-none');
            additionalBrandingFields.insertBefore('.add_additional_branding');
        });
    }
}

export default Events;
